import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TooltipModule } from 'primeng/tooltip';
import { MessageService, ConfirmationService } from 'primeng/api';
import { EstadosService } from '../../../core/services/estados.service';
import { Estado } from '../../../shared/models/system';

@Component({
  selector: 'app-estados-admin',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TableModule,
    ButtonModule,
    DialogModule,
    InputTextModule,
    ToastModule,
    ConfirmDialogModule,
    TooltipModule
  ],
  providers: [MessageService, ConfirmationService],
  templateUrl: './estados-admin.html',
  styleUrls: ['./estados-admin.css']
})
export class EstadosAdminComponent implements OnInit {
  list: Estado[] = [];
  item: Partial<Estado> = {};
  dialog: boolean = false;
  submitted: boolean = false;

  constructor(
    private service: EstadosService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.load();
  }

  load() {
    this.service.getAll().subscribe({
      next: (data) => {
        this.list = data;
        this.cdr.detectChanges();
      }
    });
  }

  openNew() {
    this.item = { isActive: true };
    this.submitted = false;
    this.dialog = true;
  }

  edit(row: Estado) {
    this.item = { ...row };
    this.dialog = true;
  }

  save() {
    this.submitted = true;
    if (this.item.nombreEstado?.trim()) {
      const req = this.item.id
        ? this.service.update(this.item.id, this.item as Estado)
        : this.service.create(this.item);
      req.subscribe({
        next: () => {
          this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Estado guardado' });
          this.load();
          this.dialog = false;
        }
      });
    }
  }

  toggle(row: Estado) {
    this.confirmationService.confirm({
      message: `¿${row.isActive ? 'Desactivar' : 'Activar'} ${row.nombreEstado}?`,
      header: 'Confirmar Estado',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.service.toggle(row.id).subscribe(() => this.load());
      }
    });
  }
}
